import { ref, watch } from 'vue'

// Theme state is manually controlled and persisted in localStorage. We
// intentionally do NOT follow `prefers-color-scheme` — the app defaults to
// light for every new visitor and only flips to dark when the user toggles.

const STORAGE_KEY = 'stmnc.theme'
const theme = ref(readInitialTheme())

function readInitialTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'light' || stored === 'dark') return stored
  } catch {
    // ignore (SSR / private-mode quirks)
  }
  return 'light'
}

function applyTheme(value) {
  const root = document.documentElement
  // Bulma 1.x reads [data-theme] and overrides its prefers-color-scheme block
  // when the attribute is set explicitly.
  root.setAttribute('data-theme', value)
  // PrimeVue's Aura preset is configured with darkModeSelector: '.app-dark'
  root.classList.toggle('app-dark', value === 'dark')
}

applyTheme(theme.value)

watch(theme, (v) => {
  applyTheme(v)
  try {
    localStorage.setItem(STORAGE_KEY, v)
  } catch {
    // ignore
  }
})

export function useTheme() {
  function toggle() {
    theme.value = theme.value === 'dark' ? 'light' : 'dark'
  }
  function setTheme(v) {
    if (v === 'light' || v === 'dark') theme.value = v
  }
  return { theme, toggle, setTheme }
}
